import React, {memo} from "react";
import {IconCross} from "./icons";
import styles from "../../../styles/components/filterItem.module.scss";

const FilterItem = memo(({
                             className = "", name, active, handleClick, handleKeyDown, rightText, isCross, value, testId = "test",
                         }) => (
    <div
        className={`fs_facet-search--filterItem ${className} ${styles.item} ${active ? styles.active : " "}`}
        onClick={() => handleClick(value, active)}
        onKeyDown={(e) => handleKeyDown(e, value, active)}
        data-testid={testId}
        data-value={value}
        tabIndex={0}
        aria-label={`${name}, ${rightText} resultaten`}
        role={"button"}
    >
        <label className={`fs_facet-search--filterItem-label ${styles.label}`}
               dangerouslySetInnerHTML={{__html: name}}/>
        <div className={`fs_facet-search--filterItem-option ${styles.option}`}>
            {
                isCross
                    ? <span className={`fs_facet-search--filterItem-cross ${styles.cross}`}><IconCross/></span>
                    : <><span className={`fs_facet-search--filterItem-text ${styles.text}`}>{rightText}</span><span
                        className={`fs_facet-search--filterItem-cross ${styles.cross}`}><IconCross/></span></>
            }
        </div>
    </div>
));

export default FilterItem;
